'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

require('./SidebarHeader.less');

var SidebarHeader = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    title: PropTypes.node.isRequired,
    subtitle: PropTypes.node
  },

  className: 'SidebarHeader',

  render() {
    return (
      <div className={this.getClassName()}>
        <div className='SidebarHeader-title'>
          {this.props.title}
        </div>

        {this.props.subtitle &&
          <div className='SidebarHeader-subtitle'>
            {this.props.subtitle}
          </div>
        }
      </div>
    );
  }
});

module.exports = SidebarHeader;


/** WEBPACK FOOTER **
 ** ./molecules/SidebarHeader.jsx
 **/